import EmptyImagesListIcon from '@/common/assets/icons/emptyImagesList.svg?react';
import Typography from '@/common/components/base/typography/Typography';
import ImageCard from '@/common/components/imageGallery/components/ImageCard';
import { ImagesListName } from '@/common/utils/ImagesListName';
import { getDamagedAdjusterAttachedImagesQueryOptions } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getDamagedAdjusterAttachedImages/getDamagedAdjusterAttachedImagesQueryOptions';
import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';
import { css } from 'styled-system/css';
import { Box, Flex } from 'styled-system/jsx';
import { grid } from 'styled-system/patterns';

const ShowCulpritDocumentImagesTab = () => {
  const { id } = useParams();

  const { data: imagesData } = useQuery(
    getDamagedAdjusterAttachedImagesQueryOptions({
      id: id!,
      damaged_id: undefined,
      type: 'document',
      fileType: 'culprit',
    }),
  );
  return (
    <>
      <Typography textStyle="b1" color="purple-1" my="24px">
        تصاویر مدارک
      </Typography>
      {imagesData?.vehicle?.length ? (
        <Flex
          gap="1rem"
          maxWidth="maxContainer"
          margin="auto"
          mt="1.5rem"
          className={grid({ columns: 2 })}
        >
          {imagesData?.vehicle?.map((vehicleImages, index) => {
            return (
              <ImageCard
                key={vehicleImages.id}
                imageData={{
                  name: ImagesListName({
                    titleType: 'document',
                    index,
                  }),
                  src: vehicleImages.image,
                }}
              />
            );
          })}
        </Flex>
      ) : (
        <Box mt="100px">
          <EmptyImagesListIcon className={css({ mx: 'auto' })} />
        </Box>
      )}
    </>
  );
};

export default ShowCulpritDocumentImagesTab;
